import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import { toogleButton } from "../../assets/styles/unoTheme";
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { getActiveRegimes, CONSOLIDATED_LABEL, CONSOLIDATED_TOGGLE_VALUE } from './accountRegimes';

//A partir daqui os botões não caberiam na barra de cabeçalho com o minWidth padrão de 90px,
//que é fixado em unoTheme.toogleButton
const COMPACT_FROM_OPTIONS = 5;

const useStyles = makeStyles((theme) => ({
    toogleButton: toogleButton,
    compact: {
        '& .MuiButtonBase-root': {
            minWidth: 'unset',
            padding: '8px 10px',
            fontSize: '0.8em',
        },
    },
}));

export default function MyToggleSegregationButton(props) {

    const classes = useStyles();

    const { value, handleValue, disabled, clientOn, marginRight } = props;

    //Consolidada continua sendo null (e não 0): é o contrato que os handleFormat/handleSegregation
    //das telas já esperam
    const options = [
        { value: CONSOLIDATED_TOGGLE_VALUE, label: CONSOLIDATED_LABEL },
        ...getActiveRegimes(clientOn).map(regime => ({
            value: regime.id,
            label: regime.shortLabel,
        })),
    ];

    return (
        <ToggleButtonGroup
            style={
                { marginRight: marginRight ? '16px' : '0px' }
            }
            className={
                options.length > COMPACT_FROM_OPTIONS
                    ? `${classes.toogleButton} ${classes.compact}`
                    : classes.toogleButton
            }
            exclusive
            value={value}
            onChange={handleValue} >
            {
                options.map(option => (
                    <ToggleButton
                        key={'segregation-' + option.value}
                        value={option.value}
                        disabled={disabled}
                        aria-label={option.label}>
                        {option.label}
                    </ToggleButton>
                ))
            }
        </ToggleButtonGroup>
    )
}
